import { FC, HTMLAttributes, useState, useEffect } from "react";
import clsx from "classnames";
import { useStyles } from "./Checkbox.style";
import { Icon } from "../Icon/Icon";

interface ICheckboxProps {
  checked?: boolean;
  onChange?: (checked?: boolean) => void;
  disabled?: boolean;
  type?: "checkbox" | "radio" | "check-circle";
}

export const Checkbox: FC<ICheckboxProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { id, checked, onChange, disabled, type = "checkbox" } = props;
  const [checkedInput, setCheckedInput] = useState(checked);

  const onChangeCheckbox = () => {
    if (disabled) return;
    onChange?.(!checkedInput);
    setCheckedInput(!checkedInput);
  };

  useEffect(() => {
    setCheckedInput(checked);
  }, [checked]);

  return (
    <div
      id={id}
      className={clsx(
        classes.checkbox,
        { disabled },
        { checked: checkedInput },
        type,
      )}
      onClick={onChangeCheckbox}
    >
      {checkedInput &&
        (type === "radio" ? (
          <span className={classes.radioDot} />
        ) : (
          <Icon name="icon-small-bold-check" size={12} />
        ))}
    </div>
  );
};
